import React from "react";
import { prebuildData } from "../../../../lib/prebuild-data";
import { EventPane } from "../../../core/event_pane";

export type FilterBarTextButtonProps = {
    text: string;
    selected?: boolean;
    onClick?: () => void;
    paneClassNames?: string[];
    disabled?: boolean;
};

export function FilterBarTextButton({text,selected = false,onClick = () => {},paneClassNames,disabled = false}:FilterBarTextButtonProps)
{
    const { collectionFilterControls: { backgroundColor,color,highlightColor,hoverColor } } = prebuildData.getActiveTheme();

    return (
        <>
            <div className={"container"+(selected?" selected":"")+(disabled?" disabled":"")}>
                {text.split("\n").map((line,index) => (<React.Fragment key={index}>{line}<br/></React.Fragment>))}
                {!disabled?<EventPane onClick={onClick} paneClassNames={paneClassNames} />:null}                
            </div>
            <style jsx>{`
            .container {
                position: relative;
                text-align: center;
                color: ${color};
                font-weight: 700;
                font-size: 15.5rem;
                letter-spacing: 0.5rem;
                padding: 19rem 0rem;
                --duration: var(--action-switch-transition-duration);
                transition: color var(--duration);
            }

            .container.disabled {
                color: #aaa;
            }

            .container.selected {
                color: ${highlightColor};
            }

            .container.hover:not(.selected) {
                color: ${hoverColor};
            }

            .container.touchdown {
                background-color: rgba(0,0,0,0.03);
            }

            @media screen and (max-width: 1300px) and (max-height: 775px) {
                .container {
                    padding: 15rem 0rem;
                    font-size: 15rem;
                }
            }      
            `}</style>
        </>
    );
}   